export enum TipoEtapa{
  TEXTO = "Texto",
  ENTRADA = "Entrada",
  LISTA = "Lista",
  OPCAO_LISTA = "Opção da Lista",
  REQUISICAO = "Requisição",
  TEXTO_VARIAVEIS = "Texto com variáveis",
  CANAL = "Canal",
  CAPTURA = "Captura",
  REQUISICAO_RETORNO = "Requisição com retorno",
  ACAO = "Ação",
  AGENTE_IA_DIFY = "Agent AI (Dify)",
}
